module.exports = ".tags-input .inputs {\n  display: flex;\n}\n\n.tags-input .inputs i {\n  font-size: 20px;\n  cursor: pointer;\n}\n"